import React, { useState } from "react"

import { ReactComponent as OnboardActiveSvg } from 'resources/icons/space/onboard_solid.svg'
import { ReactComponent as ModuleSvg } from 'resources/icons/general/module_pt1.svg'
import { ReactComponent as ModuleActiveSvg } from 'resources/icons/general/module_solid.svg'
// import { ReactComponent as DealSvg } from 'resources/icons/general/deal_pt1.svg'
// import { ReactComponent as DealActiveSvg } from 'resources/icons/general/deal_solid.svg'
// import { ReactComponent as GuideSvg } from 'resources/icons/general/guide_pt1.svg'
// import { ReactComponent as GuideActiveSvg } from 'resources/icons/general/guide_solid.svg'
import { ReactComponent as TemplateSvg } from 'resources/icons/general/template_pt1.svg'
import { ReactComponent as TemplateActiveSvg } from 'resources/icons/general/template_solid.svg'

import * as st from './Modules.styled.js'

const Modules = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <st.Wrap>
      <st.Tabs>
        <st.Tab
          isActive={activeIndex === 0}
          onClick={() => setActiveIndex(0)}
        >
          {activeIndex === 0 ? <OnboardActiveSvg /> : <st.OnboardIcon />}
          Onboarding Projects
        </st.Tab>
        <st.TabDivider />
        <st.Tab
          isActive={activeIndex === 1}
          onClick={() => setActiveIndex(1)}
        >
          {activeIndex === 1 ? <ModuleActiveSvg /> : <ModuleSvg />}
          Customer Portal
        </st.Tab>
        {/* <st.TabDivider /> */}
        {/* <st.Tab */}
        {/*   isActive={activeIndex === 2} */}
        {/*   onClick={() => setActiveIndex(2)} */}
        {/* > */}
        {/*   {activeIndex === 2 ? <DealActiveSvg /> : <DealSvg />} */}
        {/*   Sales Deal Room */}
        {/* </st.Tab> */}
        {/* <st.TabDivider /> */}
        {/* <st.Tab */}
        {/*   isActive={activeIndex === 3} */}
        {/*   onClick={() => setActiveIndex(3)} */}
        {/* > */}
        {/*   {activeIndex === 3 ? <GuideActiveSvg /> : <GuideSvg />} */}
        {/*   Resource Library */}
        {/* </st.Tab> */}
        <st.TabDivider />
        <st.Tab
          isActive={activeIndex === 4}
          onClick={() => setActiveIndex(4)}
        >
          {activeIndex === 4 ? <TemplateActiveSvg /> : <TemplateSvg />}
          Templates
        </st.Tab>
      </st.Tabs>
      <st.ScreenSection
        activeIndex={activeIndex}
      >
        <st.ScreenWrap key={activeIndex}>
          {activeIndex === 0 &&
           <st.Screen
             src="//cdn-platform.scope-dev.ws/website/images/screens/index/main/dashboard.webp"
             srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/main/dashboard.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/main/dashboard@2x.webp 2x"
           />}
          {activeIndex === 1 &&
           <st.Screen
             src="//cdn-platform.scope-dev.ws/website/images/screens/index/main/cfp.webp"
             srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/main/cfp.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/main/cfp@2x.webp 2x"
           />}
          {activeIndex === 2 &&
           <st.Screen
             src="//cdn-platform.scope-dev.ws/website/images/screens/sales-room.webp"
             srcSet="//cdn-platform.scope-dev.ws/website/images/screens/sales-room.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/sales-room@2x.webp 2x"
           />}
          {activeIndex === 3 &&
           <st.Screen
             src="//cdn-platform.scope-dev.ws/website/images/screens/library-v2.webp"
             srcSet="//cdn-platform.scope-dev.ws/website/images/screens/library-v2.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/library-v2@2x.webp 2x"
           />}
          {activeIndex === 4 &&
           <st.Screen
             src="//cdn-platform.scope-dev.ws/website/images/screens/index/main/templates.webp"
             srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/main/templates.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/main/templates@2x.webp 2x"
           />}
        </st.ScreenWrap>
      </st.ScreenSection>
    </st.Wrap>
  )
}

export default Modules
